import Vue from 'vue'
import VueRouter from 'vue-router'

import AuthGuard from './auth-guard';

// import AllUsers from "../views/AllUsers";
import AllUsers from  "../views/AllCancerUsers";
// import UserList from "../views/UserList";
import UserProfile from "../views/UserProfile";
import SignIn from "../views/SignIn";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/all-users'
    },
    {
        path: '/all-users',
        name: 'AllUsers',
        component: AllUsers,
        beforeEnter: AuthGuard,
        meta: {
            title: 'Adhera - Todos Usuarios'
        }
    },
/*     {
        path: '/my-users',
        name: 'MyUsers',
        component: UserList,
        beforeEnter: AuthGuard,
        meta: {
            title: 'MejoraCare - Mis usuarios asignados'
        }
    }, */
    {
        path: '/user/:id',
        name: 'UserProfile',
        component: UserProfile,
        beforeEnter: AuthGuard,
        meta: {
            title: 'Adhera - Perfil de Usuario'
        }
    },
    {
        path: '/signin',
        name: 'signin',
        component: SignIn,
        meta: {
            title: 'Adhera - Entrar'
        }
    },
    {
        path: '/about',
        name: 'About',

        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
